import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import tick from '../Assets/yes-alt-svgrepo-com (2) 53.png'
import img from '../Assets/123.png'
import img2 from '../Assets/Group 1000005998.png'
import icon from '../Assets/w1 (1).png'
import { Link } from 'react-router-dom'
import SEOData from '../Components/SEOData'
function Join() {
  return (
    <>
       <Navbar/>
       <SEOData PageName={'join'} />
        <div className='banner2'>
        <h4>Are you a Hostess/Model?</h4>
        <h2>Join the Revolution</h2>
        <p>Turn your free time into money by accompanying clients to dinners, events or trips.Organize independently, with no costs or commissions.</p>
        <p>Home - Are you a Hostess / Model?</p>


        </div>
        <div className='Lovebetter'>
        <div className='Lovebetter-left'>
        <h3>Enjoy meeting fascinating people while earning money in your free time.</h3>
        <br/>
        <p>A job that you can do in your free time and that will allow you to meet new people and visit new places. Accompany clients and offer your company in exchange for a fee agreed directly with them. Zero-tolerance policy for sexual requests/offers.</p>
        <br/>
        <br/>
        <div className='Lovebetter-righttick'>
        <h2>
            <img src={tick}/>
            Company for aperitifs, lunches and dinners
        </h2>

        </div>
        <br/>
        <div className='line'></div>
        <br/>
        <div className='Lovebetter-righttick'>
        <h2>
            <img src={tick}/>
            Participation in fairs and events
        </h2>

        </div>
        <br/>
        <div className='line'></div>
        <br/>
        <div className='Lovebetter-righttick'>
        <h2>
            <img src={tick}/>
            Business trips and holidays
        </h2>

        </div>
        <br/>
        <div className='line'></div>
        <br/>
        <div className='Lovebetter-righttick'>
        <h2>
            <img src={tick}/>
            Model for photo shoots
        </h2>

        </div>
        <br/>
        <br/>
        <Link to='/signup'>

<button className='CreateProfile'>Create Profile Now</button>
        </Link>
        </div>
        <div className='Lovebetter-right'>
        <img src={img}/>
        
        </div>
        
        </div>
        <div className='Whywe'>
        <div className='Whywe-left'>
        <img src={img2}/>

</div>
 <div className='Whywe-right'>
 <h3>Select the requests you want.</h3>
 <br/>
 <br/>
 <p>Usually the average fee requested by hostesses/models is $70/hour, but it can vary based on requests, times, etc. Decide your fee and make arrangements in total autonomy. Wostess does not require any percentage or commission. Remember to personally fulfill the tax obligations in force in your country.
 </p>
 <br/>
        <br/>
        <Link to='/signup'>

<button className='CreateProfile'>Create Profile Now</button>
        </Link>
</div>

        </div>
        <br/>
        <br/>
        <div className='center'>
        </div>
        <div className='Workwhenever'>
        <div className='Workwhenever-left'>
        <img src={img}/>

</div>
  <div className='Workwhenever-right'>
  <h2>Start receiving Requests.<br/>Without Agency.</h2>
  <br/>
  <br/>

  <div className='Workwhenever-div'>
  {/* <img src={icon}/> */}
  <div>
    <div className='Workwhenever-circle'>
    <i class="bi bi-gem"></i>
    </div>
  </div>
  <div>
    <h3>Work whenever you want</h3>
    <p>You choose what to do and when. Make direct arrangements with customers through the integrated chat for maximum privacy.</p>
  </div>
  <div>

  </div>

  </div>
  <br/>
  <div className='Workwhenever-div'>
  <div>
    <div className='Workwhenever-circle'>
  $
    </div>
  </div>
  <div>
    <h3>Free Registration | No commissions</h3>
    <p>Registration is completely free.
    Users who want to unlock chat with a hostess/model pay a small fee in credits. Contacts and agreements will be private and without any mediation.</p>
  </div>
  <div>

  </div>

  </div>
  <br/>
  <div className='Workwhenever-div'>
  <div>
    <div className='Workwhenever-circle'>
    <i class="bi bi-shield-fill-check"></i>
    </div>
  </div>
  <div>
    <h3>Maximum confidentiality</h3>
    <p>You can make your photo and profile private.
    We will not disclose your personal contact details to anyone. Users will only be able to write to you in Wostess' encrypted chat.</p>
  </div>
  <div>

  </div>

  </div>

</div>
        </div>
        <Footer/>
    </>
  )
}

export default Join